import ActionTypes from "../constants/ActionTypes";

const initialState = {
  isFetching: false,
  response: null,
  error: null,
};

const userCreateReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_USER_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case ActionTypes.FETCH_USER_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        response: action.payload,
        error: null,
      };

    case ActionTypes.FETCH_USER_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default userCreateReducer;
